"use client";

import { regions } from "@/data/main-data";
import { useGetProperties } from "@/hooks/main-hook";
import { trunkAboutDesc } from "@/utils/trunck";
import { useLocale, useTranslations } from "next-intl";
import Image from "next/image";
import Link from "next/link";
// import { FaHeart } from "react-icons/fa";
import { PropertyCardSkeleton } from "../loading/PropertyCardSkeleton";

export default function RecentlyAdded() {
  const t = useTranslations("Home");
  const locale = useLocale();

  const { data, isLoading } = useGetProperties({
    page: 1,
    limit: 4,
    tab: "all",
  });

  const properties = data?.properties || [];

  return (
    <div>
      <div className="sm:container px-4 md:px-0 lg:w-[85%] mx-auto mb-8">
        <div className="flex items-center gap-5 h-fit">
          <h2 className="text-2xl font-extrabold text-main">
            {t("recentlyAdded")}
          </h2>
          <span className="flex-1 w-full h-1 bg-main"></span>
        </div>
        {isLoading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-10">
            {[...Array(4)].map((_, index) => (
              <PropertyCardSkeleton key={index} />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-10">
            {properties?.map((property: any) => {
              const location = regions.find(
                (e) => e.value === property?.region
              );
              const isSale = property?.is_sale;
              const price =
                property?.rent_type === "daily"
                  ? property?.price_per_day
                  : property?.price_per_year;

              return (
                <div
                  key={property.id}
                  className="border border-gray-200 rounded-2xl pb-10"
                >
                  <div className="relative w-full min-h-72">
                    <Image
                      src={property?.thumbnail}
                      alt={
                        locale === "ar" ? property.title_ar : property.title_en
                      }
                      layout="fill"
                      objectFit="cover"
                      className="rounded-t-2xl"
                      loading="lazy"
                    />
                    <div className="overlay absolute top-0 left-0 bg-black/50 w-full h-full rounded-t-xl"></div>
                    {/* <div className="absolute top-5 right-3 z-10">
                  <button className="cursor-pointer">
                    <FaHeart
                      size={24}
                      className={`${
                        property.isFav ? "text-red-500" : "text-black"
                      }`}
                    />
                  </button>
                </div> */}
                  </div>
                  <div className="px-5 mt-4">
                    <h3 className="text-lg font-semibold ">
                      {locale === "ar" ? property.title_ar : property.title_en}
                    </h3>
                    <p className="text-sm text-gray-500 mt-1">
                      {locale === "ar"
                        ? location?.label_ar
                        : location?.label_en}
                    </p>
                    <div className="flex items-center gap-2 mt-3">
                      <span className="text-main text-lg font-bold">
                        {isSale
                          ? property?.sale_price?.toLocaleString()
                          : price?.toLocaleString()}
                        <Image
                          src={`/sar.png`}
                          alt="SAR"
                          width={16}
                          height={16}
                          className="inline-block mb-1 mx-1.5"
                        />
                        {!isSale && (
                          <span className="text-main text-sm">
                            {" "}
                            / {t(`${property?.rent_type}`)}
                          </span>
                        )}
                      </span>
                    </div>

                    <p className="text-sm text-gray-600 mt-2">
                      {trunkAboutDesc(
                        locale === "ar"
                          ? property.description_ar
                          : property.description_en,
                        100
                      )}
                    </p>

                    <button className="mt-5">
                      <Link
                        href={`/properties/${property.slug}`}
                        className="text-sm bg-main text-white px-5 py-2 font-semibold mt-2 inline-block rounded-xl"
                      >
                        {t("viewDetails")}
                      </Link>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
